const JWT_DOMAIN = 'jwt'

export default JWT_DOMAIN
